// extracted by mini-css-extract-plugin
export default {"image":"rich-text-renderer-module--image--e6c37"};